import { SuccessModal } from "@packages/ui/components";
import { EXPIRED } from "@public/index";
import { signOut } from "next-auth/react";
import Image from "next/image";

const SessionExpired = ({ open }: { open: boolean }) => {
  const handleSignin = () => {
    localStorage.removeItem("sessionExpiryAlert");
    localStorage.removeItem("selectedSubItem");
    localStorage.removeItem("terminal_file_statuses");
    localStorage.removeItem("userReactions");
    localStorage.removeItem("guidedTour");
    localStorage.removeItem("shareholderGuide");
    sessionStorage.clear();
    signOut();
  };
  return (
    <>
      <SuccessModal
        open={open}
        iconSvg={<Image src={EXPIRED} alt="expiredIcon" />}
        title="Session Expired!"
        desc="You were signed out of your account. Please sign in again to continue."
        containedButtonTitle="Login Now"
        styleColor="#0E8345"
        containedOnClick={handleSignin}
      />
    </>
  );
};

export default SessionExpired;
